import styles from "./Section.module.css";

export default function Section({
  id,
  eyebrow,
  title,
  subtitle,
  bg = "white",
  className = "",
  children,
}) {
  return (
    <section
      id={id}
      className={`${styles.section} ${styles[bg]} ${className}`}
    >
      <div className="container">
        {(eyebrow || title || subtitle) && (
          <header className={styles.head} data-reveal="">
            {eyebrow && <span className="eyebrow">{eyebrow}</span>}
            {title && <h2 className={styles.title}>{title}</h2>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </header>
        )}
        {children}
      </div>
    </section>
  );
}
